import { Model } from '@/clients/http'

import { RoleHttpParams, RoleResponses } from '@/types'

export class RoleModel extends Model {
  // Define correlation keys for Redux state management
  public static readonly correlations = {
    GET_LIST: 'GET_ROLE_LIST',
    GET_BY_ID: 'GET_ROLE_BY_ID',
    CREATE: 'CREATE_ROLE',
    UPDATE: 'UPDATE_ROLE',
    DELETE: 'DELETE_ROLE',
  }

  // Define endpoint builders
  public static readonly endpoints = {
    getList: (props?: RoleHttpParams.GetList) =>
      this.createEndpoint({
        url: '/api/backoffice/role',
        params: props?.params,
        query: props?.query,
      }),

    getById: (props?: RoleHttpParams.GetById) =>
      this.createEndpoint({
        url: '/api/backoffice/role/:id',
        params: props?.params,
        query: props?.query,
      }),

    create: (props?: RoleHttpParams.Create) =>
      this.createEndpoint({
        url: '/api/backoffice/role',
        params: props?.params,
        query: props?.query,
      }),

    update: (props?: RoleHttpParams.Update) =>
      this.createEndpoint({
        url: '/api/backoffice/role/:id',
        params: props?.params,
        query: props?.query,
      }),

    delete: (props?: RoleHttpParams.Delete) =>
      this.createEndpoint({
        url: '/api/backoffice/role/:id',
        params: props?.params,
        query: props?.query,
      }),
  }

  /**
   * Get list of roles
   */
  public static readonly getList = async (props?: RoleHttpParams.GetList) => {
    return this.createHttpRequest<RoleResponses.GetList, RoleResponses.GetListError>({
      correlationKey: this.correlations.GET_LIST,
      payload: {
        method: 'get',
        url: this.endpoints.getList(props),
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  /**
   * Get role details by ID
   */
  public static readonly getById = async (props: RoleHttpParams.GetById) => {
    return this.createHttpRequest<RoleResponses.GetById, RoleResponses.GetByIdError>({
      correlationKey: this.correlations.GET_BY_ID,
      payload: {
        method: 'get',
        url: this.endpoints.getById(props),
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  /**
   * Create a new role
   */
  public static readonly create = async (props: RoleHttpParams.Create) => {
    return this.createHttpRequest<RoleResponses.Create, RoleResponses.CreateError>({
      correlationKey: this.correlations.CREATE,
      payload: {
        method: 'post',
        url: this.endpoints.create(props),
        body: props.body,
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  /**
   * Update an existing role
   */
  public static readonly update = async (props: RoleHttpParams.Update) => {
    return this.createHttpRequest<RoleResponses.Update, RoleResponses.UpdateError>({
      correlationKey: this.correlations.UPDATE,
      payload: {
        method: 'put',
        url: this.endpoints.update(props),
        body: props.body,
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  /**
   * Delete a role
   */
  public static readonly delete = async (props: RoleHttpParams.Delete) => {
    return this.createHttpRequest<RoleResponses.Delete, RoleResponses.DeleteError>({
      correlationKey: this.correlations.DELETE,
      payload: {
        method: 'delete',
        url: this.endpoints.delete(props),
        useBearerToken: true,
      },
      store: props?.store,
    })
  }
}
